import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpClientWrapper } from './http-client-wrapper';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  constructor(private http: HttpClient) {}

  createHttpClient(baseUrl: string): HttpClientWrapper {
    return new HttpClientWrapper(baseUrl, this.http);
  }
}
